import React, { useState } from 'react';
import { UserIcon, ChevronDownIcon, LogOutIcon, MenuIcon, XIcon } from 'lucide-react';
interface HeaderProps {
  isAuthenticated: boolean;
  onLogout: () => void;
}
export function Header({
  isAuthenticated,
  onLogout
}: HeaderProps) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  return <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10" data-id="element-132">
      <div className="container mx-auto px-4 py-3" data-id="element-133">
        <div className="flex items-center justify-between" data-id="element-134">
          <div className="flex items-center" data-id="element-135">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wcGJehFU8moW1Bqmivv7jn/ethswitch_logo-1.png" alt="EthSwitch Logo" className="h-8" data-id="element-136" />
            <span className="ml-3 text-xl font-semibold text-[#1A1F36] whitespace-nowrap" data-id="element-137">
              EthBridge Enterprise portal
            </span>
          </div>
          {isAuthenticated ? <div className="relative" data-id="element-138">
              <button onClick={() => setShowUserMenu(!showUserMenu)} className="flex items-center space-x-2 text-gray-700 hover:text-[#F58220] focus:outline-none" data-id="element-139">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-140">
                  <UserIcon size={18} data-id="element-141" />
                </div>
                <span className="hidden md:inline" data-id="element-142">Admin User</span>
                <ChevronDownIcon size={16} data-id="element-143" />
              </button>
              {showUserMenu && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200" data-id="element-144">
                  <a href="#profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-145">
                    Profile
                  </a>
                  <button onClick={onLogout} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-146">
                    <LogOutIcon size={16} className="mr-2" data-id="element-147" /> Logout
                  </button>
                </div>}
            </div> : <a href="#contact" className="text-[#F58220] hover:text-[#e07619] font-medium" data-id="element-148">
              Contact Us
            </a>}
        </div>
      </div>
    </header>;
}